.table {
  border-collapse: collapse;
}

.form {
  padding-top: 5px;
  padding-bottom: 5px;
}

.form a:hover {
  text-decoration: underline;
}
